import { Instagram } from "lucide-react";
import { BRAND } from "@/lib/constants";
import { whatsappLink, generalMessage } from "@/lib/whatsapp";
import WhatsAppIcon from "./WhatsAppIcon";

export const Footer = () => {
  return (
    <footer
      className="border-t border-[var(--ovi-border)] bg-[var(--ovi-cream)] py-10"
      data-testid="main-footer"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row md:items-start md:justify-between gap-8">
        <div>
          <div className="font-serif-display text-2xl text-[var(--ovi-indigo)]">OVI</div>
          <p
            className="mt-1 text-xs sm:text-sm font-medium text-[var(--ovi-terracotta)] tracking-wide"
            data-testid="footer-website"
          >
            {BRAND.websiteDisplay}
          </p>
          <p
            className="mt-3 text-sm text-[var(--ovi-muted-ink)]"
            data-testid="footer-born-in-solapur"
          >
            Born in Solapur, Built for India.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <div className="flex flex-wrap items-center gap-5">
            <a
              href={whatsappLink(generalMessage())}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="inline-flex items-center gap-2 text-sm text-[var(--ovi-indigo)] hover:text-[var(--ovi-terracotta)] transition-colors"
              aria-label="WhatsApp OVI"
            >
              <WhatsAppIcon className="h-5 w-5" />
              WhatsApp
            </a>
            <a
              href={BRAND.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              className="inline-flex items-center gap-2 text-sm text-[var(--ovi-indigo)] hover:text-[var(--ovi-terracotta)] transition-colors"
              aria-label="Instagram OVI"
            >
              <Instagram className="h-5 w-5" />
              Instagram
              <span
                className="text-[var(--ovi-muted-ink)] font-medium"
                data-testid="footer-instagram-handle"
              >
                {BRAND.instagramHandle}
              </span>
            </a>
          </div>
          <p
            className="text-xs text-[var(--ovi-muted-ink)] italic"
            data-testid="footer-whatsapp-launch-note"
          >
            {BRAND.whatsappLaunchNote}
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 mt-8 pt-6 border-t border-[var(--ovi-border)] flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-xs text-[var(--ovi-muted-ink)]">
        <span>© {new Date().getFullYear()} OVI. All rights reserved.</span>
        <span>Direct from weavers · Solapur, Maharashtra</span>
      </div>
    </footer>
  );
};

export default Footer;
